import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '@/common/types/contract';
import { AboutSpecContract } from '@/components/Contract/AboutSpecContract/AboutSpecContract';
import { BlitzContractDetail } from '@/components/Contract/Blitz/BlitzContractDetail/BlitzContractDetail';

import { SpecContractWrapper } from '../common/SpecContractWrapper/SpecContractWrapper';

interface BlitzContractModalProps {
  status: SpecContractStatusType;
  kind: SpecContractType | PaidSpecContractType;
}

const BlitzContractModal: FC<BlitzContractModalProps> = ({ status, kind }) => {
  return (
    <SpecContractWrapper kind={kind}>
      {status === 'forViewing' ? (
        <AboutSpecContract kind={kind} />
      ) : (
        <BlitzContractDetail
          status={status}
          kind={kind as 'Blitz' | 'BlitzPlus'}
        />
      )}
    </SpecContractWrapper>
  );
};

export { BlitzContractModal };
